import React, { Component } from "react";
import PropTypes from "prop-types";

class Textarea extends Component {
	constructor(props) {
		super(props);

		this.state = {};
	}

	render() {
		const { onChange, errorMessage, placeholder, id, valid } = this.props;

		return (
			<div className="textarea-component">
				<textarea
					className={`form-control textarea-component__textarea ${
						errorMessage != undefined && errorMessage ? "textarea-component__textarea-invalid" : ""
					} ${valid ? "textarea-component__textarea-valid" : ""}`}
					placeholder={placeholder ? placeholder : 'Digite os detalhes'}
					rows="5"
					onChange={onChange}
					id={id ? id : "textarea"}
				/>
				{errorMessage != undefined && errorMessage ? (
					<p className="text-right text-invalid">{errorMessage}</p>
				) : null}
			</div>
		);
	}
}

export default Textarea;
